import { IUseTimeRangePayload } from 'hooks/utils/useTimeRange';
import { isNil } from 'lodash';
import { createContext, useContext } from 'react';
import { IChildrenProps } from 'types/ChildrenProps';
import TimeRangeType from 'types/TimeRangeType';

export const TimeRangeContext = createContext<IUseTimeRangePayload | null>(null);

export function useTimeRangeState() {
  const context = useContext(TimeRangeContext);

  if (isNil(context)) {
    throw new Error('useTimeRangeState must be nested within a TimeRangeContext.Provider.');
  }

  return context;
}

export interface ITimeRangeContextProviderProps extends IChildrenProps, IUseTimeRangePayload {
  timeRangeType: TimeRangeType;
}

export function TimeRangeContextProvider({ children, ...timeRangeValues }: ITimeRangeContextProviderProps) {
  return <TimeRangeContext.Provider value={timeRangeValues}>{children}</TimeRangeContext.Provider>;
}
